export const MAX_IMAGE_INPUT_BYTES = 100 * 1024 * 1024;
export const TARGET_IMAGE_BYTES = 4 * 1024 * 1024;

/** Bound both total pixels and longest edge without upscaling or stretching. */
export function uploadImageDimensions(width: number, height: number) {
  if (![width, height].every(n => Number.isFinite(n) && n > 0)) throw new Error("Invalid image dimensions");
  const scale = Math.min(1, 2048 / Math.max(width, height));
  return { width: Math.max(1, Math.floor(width * scale)), height: Math.max(1, Math.floor(height * scale)) };
}
